import Button from "../UI/Button";
import useLoader from "../../hooks/use-loader";
import moment from "moment/moment";
import DocumentDownloader from "../UI/DocumentDownloader";
import useAuthenticatedAxios from "../../hooks/use-authenticated-axios";

export default function ProfileRecapFiscal({ profileBailleurId }) {
  const axios = useAuthenticatedAxios();
  const [generatingRecap, generateRecap] = useLoader(async (year) => {
    const response = await axios.post(
      `/profiles/${profileBailleurId}/recap-fiscal`,
      { year },
    );
    return response.data;
  });
  const currentYear = moment().year();
  return (
    <>
      <p className={"primaryText"}>Générer le récap fiscal de l'année : </p>
      <DocumentDownloader className={"flex wrap gap10 marginT10 marginB20"}>
        {(setSignedUrl) =>
          [currentYear - 1, currentYear].map((year) => (
            <Button
              key={year}
              onClick={async () => {
                try {
                  const url = await generateRecap(year);
                  setSignedUrl(url);
                } catch (e) {
                  console.error(e);
                }
              }}
              isLoading={generatingRecap}
            >
              {year}
            </Button>
          ))
        }
      </DocumentDownloader>
    </>
  );
}
